import React from 'react';
import {observer, inject, IReactComponent} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {IVjHistoryStore} from './vj-history.stores';
import {IAppRootStore} from '../../app.root.store';
import {VjHistoryView} from './view';
import {ScreenLoader} from '../../components/screen-loader/screen-loader';

interface VjHistoryRouteViewProps {
    vjHistoryStore: IVjHistoryStore;
    rootStore: IAppRootStore;
}

@observer
export class VjHistoryRouteViewComponent extends TechseeBaseComponent<VjHistoryRouteViewProps> {
    renderInternal(): JSX.Element {
        const {vjHistoryStore} = this.props;
        const controller = vjHistoryStore.vjHistoryController;
        if (!controller) {
            return <ScreenLoader />;
        }
        return <VjHistoryView controller={controller} />;
    }
}

export const VjHistoryRouteView = inject('rootStore', 'vjHistoryStore')(VjHistoryRouteViewComponent) as IReactComponent;
